var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryFeesAndInterest32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/FeesandInterest32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconFeeInterest",
    transform: "translate(7.000000, 5.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blank-page"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.05,3 L-1.05,19 L14.3740242,19 L19,14.4436771 L19,3 L-1.05,3 Z M-2,2 L20,2 L20,15 L15,20 L-2,20 L-2,2 Z",
    id: "Page-stroke",
    transform: "translate(9.000000, 11.000000) rotate(-90.000000) translate(-9.000000, -11.000000) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Corner",
    points: "12 0 12.9989014 0 12.9989014 5 18 5 18 6 12 6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "%",
    transform: "translate(4.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,10 C5.8954305,10 5,9.1045695 5,8 C5,6.8954305 5.8954305,6 7,6 C8.1045695,6 9,6.8954305 9,8 C9,9.1045695 8.1045695,10 7,10 Z M7,8.91891892 C7.50750491,8.91891892 7.91891892,8.50750491 7.91891892,8 C7.91891892,7.49249509 7.50750491,7.08108108 7,7.08108108 C6.49249509,7.08108108 6.08108108,7.49249509 6.08108108,8 C6.08108108,8.50750491 6.49249509,8.91891892 7,8.91891892 Z",
    id: "Botton-circle"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Drawn-diagonal",
    points: "0 8 8.0244751 0.979675293 9.0244751 1.97967529 1 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,4 C0.8954305,4 0,3.1045695 0,2 C0,0.8954305 0.8954305,0 2,0 C3.1045695,0 4,0.8954305 4,2 C4,3.1045695 3.1045695,4 2,4 Z M2,2.91891892 C2.50750491,2.91891892 2.91891892,2.50750491 2.91891892,2 C2.91891892,1.49249509 2.50750491,1.08108108 2,1.08108108 C1.49249509,1.08108108 1.08108108,1.49249509 1.08108108,2 C1.08108108,2.50750491 1.49249509,2.91891892 2,2.91891892 Z",
    id: "Top-circle"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryFeesAndInterest32);
export default __webpack_public_path__ + "static/media/spendCategoryFeesAndInterest32.bec80543010afe63f73ace0f9c5a41d2.svg";
export { ForwardRef as ReactComponent };